<template>
  <el-form ref="form" :model="form" class="form_flex">
    <el-form-item prop="type">
      <el-select
        class="search-select1"
        v-model="form.type"
        placeholder="请选择类型"
      >
        <el-option
          v-for="(item, index) in typeList"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>

    <el-form-item prop="kewWord">
      <el-input
        class="search-input"
        v-model="form.kewWord"
        placeholder="请输入关键字"
      ></el-input>
    </el-form-item>

    <el-form-item class="btn">
      <el-button @click="onSearch" icon="el-icon-search" size="small"
        >查询</el-button
      >
      <el-button size="small" icon="el-icon-plus" @click="resetForm"
        >清空</el-button
      >
      <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
        >刷新</el-button
      >
      <el-button
        size="small"
        icon="el-icon-plus"
        @click="$emit('openAddAuth', true)"
        type="primary"
        v-if="roleList[path].includes('_Add')"
        >新增</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'robotSearchBar',
  // 与 layout 组件配合使用 provide / inject组合
  inject: ['reload'], // 注入reload方法
  props: ['rolesList'],
  data() {
    return {
      // 表单内容
      form: {
        type: '',
        kewWord: '',
      },
      path: '',
      roleName: '',
      typeList: [
        { value: 1, label: '标准' },
        { value: 2, label: '普通' },
      ],
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['roleList']),
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  methods: {
    // 搜索，触发父组件请求数据的方法
    async onSearch() {
      this.$emit('search', this.form);
    },

    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 清空表单
    resetForm() {
      this.$refs['form'].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.form_flex {
  display: flex;
}

.search-input {
  margin: 0 10px;
  width: 170px;
}

.search-select1 {
  width: 120px;
}

.select {
  margin-left: 10px;
}

button {
  height: 40px;
  margin-left: 10px;
}

/deep/ .el-form-item__content {
  display: flex;
}
</style>
